import klineStyle from '../echartsOption/klineStyle';

/**
 * 定义K线类
 */
class KLINE {
    /**
     * K线类构造函数
     * @param {Array<Number>} klineDatas K线图数据(开盘价，收盘价，最低价，最高价)
     * @param {Function} getMarkPointOptionByKey 获取指定Key的MarkPoint选项
     * @param {Object} markPoint 需要标注的点
     * @param {Array<String>} times 交易时间序列
     */
    constructor(klineDatas = []) {
        this.klineDatas = klineDatas;

        this.seriesOption = {
            name: 'K线',
            type: 'k',
            data: [],
            itemStyle: {
                normal: klineStyle.lineColor
            },
            markPoint: {
                data: []
            },
            markLine: {
                label: {
                    position: 'end',
                    backgroundColor: '#F2F6FF',
                    color: '#308CDD',
                    fontSize: 10,
                    margin: 0,
                    padding: [2, 8, 2, 8],
                    borderColor: '#D1D1D6',
                    borderWidth: 1,
                    formatter(param) {
                        return param.data.yAxis;
                    }
                },
                lineStyle: {
                    width: 0
                },
                data: [],
                symbolSize: 0
            }
        };
    }

    /**
     * 计算方法（实现接口统一需要提供的方法）
     */
    calculate() {}

    /**
     * 生成series选项
     * @param {Array<String>} showMarkPointTypes 要显示的MarkPoint类型
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption(showMarkPointTypes) {
        if (this.klineDatas.length === 0) {
            return {};
        }

        let latestClose = this.klineDatas[this.klineDatas.length - 1][1];
        let markLineDatas = [
            {
                yAxis: latestClose
            }
        ];
        this.seriesOption.data = this.klineDatas;
        this.seriesOption.markLine.data = markLineDatas;
        return this.seriesOption;
    }
}

export default KLINE;



// WEBPACK FOOTER //
// ./src/controller/series/KLINE.js